import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CommissionReviewItem {
  sourceType: 'BOOKING' | 'TOUR';
  id: string; code: string; bookingCode: string; customerName: string; tripName: string;
  travelDate: string; travelerCount: number; saleName: string; bookingAmount: number | string;
saleCommission: number | string; specialCommission: number | string;
  commissionRate: number | string | null;
  commissionAmount: number | string; attachmentFileName: string; attachmentUrl: string | null;
  recoveryDeduction: number | string;
  netPaymentAmount: number | string;
  purchaseOrderUrl: string | null;
  transactionRef: string | null;
  receiptUrl: string; status: 'WAITING_PAYMENT'; submittedAt: string;
}

@Injectable({ providedIn: 'root' })
export class CommissionReviewService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/commissions/accounting-review`;
  async getPending(): Promise<CommissionReviewItem[]> {
    const response = await firstValueFrom(this.http.get<{ commissions: CommissionReviewItem[] }>(this.apiUrl, { withCredentials: true }));
    return response.commissions;
  }
  async approve(
    id: string,
    receiptUrl: string,
    transactionDate: string,
    transactionTime: string,
    sourceType: CommissionReviewItem['sourceType'],
  ): Promise<void> {
    await firstValueFrom(
      this.http.patch(
        `${this.apiUrl}/${id}/approve`,
        { receiptUrl, transactionDate, transactionTime, sourceType },
        { withCredentials: true },
      ),
    );
  }
  async reject(id: string, sourceType: CommissionReviewItem['sourceType']): Promise<void> { await firstValueFrom(this.http.patch(`${this.apiUrl}/${id}/reject`, { sourceType }, { withCredentials: true })); }
  resolveFileUrl(fileUrl: string): string {
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    if (/^https?:\/\//i.test(environment.apiUrl)) return `${new URL(environment.apiUrl).origin}${fileUrl}`;
    return fileUrl;
  }
}
